<ul class="progressbar d-none d-md-flex">
  <li *ngFor="let step of steps" [class.active]="step.active" [ngClass]="step.iconClass">
    <span>{{step.label}}</span>
  </li>
</ul>

<div class="mobile-container">
  <ul class="progressbar-mobile d-md-none">
    <li class="progressbar-mobile-item" *ngFor="let step of steps" [class.active]="step.active"
      [class.completed]="step.completed">
      <i [class.active]="step.active" [ngClass]="step.iconClass"></i>
      <span>{{step.label}}</span>
    </li>
  </ul>
</div>